import { FC, useMemo } from 'react'
import RootPage from '../home/RootPage'
import UserContextProvider from '../../context/user/ContextProvider'
import Authorize from '../login/authorize'
import { useAuth, AuthState } from '../../hooks/useAuth'
import Spinner from '../../components/input/Spinner'
import { setTimezoneAndLocale } from '../../util/time'
import LoginPage from '../login/LoginPage'

const AppContent: FC = () => {
  const { authState } = useAuth()
  setTimezoneAndLocale()

  const getRoot = useMemo(() => {
    switch (authState) {
      case AuthState.LOADING:
        return <Spinner centerScreen />
      case AuthState.AUTHENTICATED:
        return (
          <UserContextProvider>
            <RootPage />
          </UserContextProvider>
        )
      case AuthState.UNAUTHENTICATED:
        return <LoginPage />
      case AuthState.AUTHORIZE:
        return <Authorize />
      default:
        return <div>TaskCtrl</div>
    }
  }, [authState])

  return getRoot
}

export default AppContent
